<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Import Value</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 p-4">
          <vue-select
            id="selectLimit"
            name="selectLimit"
            class="form-control"
            placeholder="--- Select namespace ---"
            v-model="namespace"
            :options="namespaces"
            close-on-select
            :empty-model-value="null"
          ></vue-select>
        </div>
      </div>
      <div class="row">
        <div class="col-12 p-4">
          <vue-csv-import
            v-model="csv"
            :fields="{
              code: {
                required: true,
                label: 'Code',
              },
              year: {
                required: false,
                label: 'Year',
              },
              new_price: {
                required: true,
                label: 'New Price',
              },
              trade_price: {
                required: true,
                label: 'Trade Price',
              },
              retail_price: {
                required: true,
                label: 'Retail Price',
              },
            }"
          >
            <div class="col-12 p-4">
              <vue-csv-toggle-headers></vue-csv-toggle-headers>
            </div>
            <div class="col-12 p-4">
              <vue-csv-errors></vue-csv-errors>
              <vue-csv-input></vue-csv-input>
            </div>
            <div class="col-12 p-4">
              <vue-csv-map></vue-csv-map>
            </div>
          </vue-csv-import>
        </div>
      </div>
      <div class="row">
        <div class="col-12 p-4">
          <div class="progress">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :aria-valuenow="percentage"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="`width: ${percentage}%`"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row" v-show="showSubmit">
        <div class="col-sm-12 col-md-12 col-xl-12">
          <div role="group" class="float-right btn-group">
            <button @click="submit" class="btn btn-success btn-sm">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import { namespaceList } from "../../controllers/data-contoller";
import { uploadValueChunk } from "../../controllers/value-contoller";

export default {
  data: () => {
    return {
      tally: 0,
      namespace: null,
      namespaces: namespaceList,
      csv: [],
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    total() {
      return this.csv.length;
    },
    showSubmit() {
      return this.total >= 1 && this.namespace !== null;
    },
    percentage() {
      if (this.csv.length >= 1) {
        return (this.tally / this.csv.length) * 100;
      }
      return 0;
    },
  },
  methods: {
    submit() {
      this.tally = 0;
      this.uploadValue(this.csv);
    },
    chunkArray(array, chunkSize) {
      return Array.from(
        { length: Math.ceil(array.length / chunkSize) },
        (_, index) => array.slice(index * chunkSize, (index + 1) * chunkSize)
      );
    },
    async uploadValue(dataArray) {
      try {
        const chunks = await this.chunkArray(dataArray, 100);
        for (const chunk of chunks) {
          const processed = await uploadValueChunk(chunk, this.namespace);
          console.log(processed);
          this.tally += processed;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
